var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetrySignature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "retry-svgrepo-com 1",
    clipPath: "url(#clip0_13214_3684)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.8389 9.9944C19.5224 10.0916 19.9976 10.7245 19.9005 11.4079C19.6033 13.4979 18.6523 15.4403 17.1838 16.9568C15.7151 18.4731 13.8044 19.486 11.725 19.8501C9.64562 20.2143 7.50436 19.911 5.60789 18.9837C4.71669 18.5481 3.90103 17.9851 3.184 17.3171L2.13389 18.3673C1.34643 19.1548 0 18.597 0 17.4834V12.5H4.98341C6.09704 12.5 6.65475 13.8464 5.86729 14.6339L4.95325 15.5479C5.47507 16.0226 6.06441 16.4242 6.70594 16.7379C8.1283 17.4333 9.73424 17.6606 11.2938 17.3876C12.8533 17.1145 14.2864 16.3549 15.3877 15.2175C16.4893 14.0801 17.2025 12.6235 17.4254 11.056C17.5226 10.3725 18.1555 9.8972 18.8389 9.9944ZM14.3921 1.01622C15.2849 1.45269 16.1017 2.01686 16.8197 2.68631L17.8661 1.63991C18.6536 0.852451 20 1.41016 20 2.5238V7.50001H15.0238C13.9101 7.50001 13.3524 6.15359 14.1399 5.36614L15.0505 4.45551C14.5277 3.97933 13.9371 3.57656 13.2941 3.26216C11.8717 2.56678 10.2658 2.33933 8.70624 2.61243C7.14671 2.88551 5.71361 3.64514 4.6122 4.78249C3.51078 5.91983 2.79752 7.37656 2.57461 8.94405C2.47741 9.62753 1.84455 10.1028 1.16107 10.0056C0.477594 9.9084 0.00231981 9.27554 0.0995183 8.59205C0.396738 6.50208 1.34773 4.55978 2.81629 3.04331C4.28485 1.52685 6.19565 0.514022 8.27501 0.149895C10.3544 -0.21423 12.4956 0.0890225 14.3921 1.01622Z",
    fill: "#0F314D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13214_3684"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetrySignature);
export default __webpack_public_path__ + "static/media/retrySignature.9c71b5690524c9b8297205428fa83699.svg";
export { ForwardRef as ReactComponent };